// Copyright 2019 Sorama B.V.

import { IWorkflowPropertyParser } from "libraries/WorkflowFramework/Interfaces/IWorkflowPropertyParser";
import { BooleanParser } from "parsers/BooleanParser";
import { AxisKindParser } from "./AxisKindParser";
import { ChannelSelectionParser } from "./ChannelSelectionParser";
import { MeasurementChannelSelectionParser } from "./MeasurementChannelSelectionsParser";
import { NumberParser } from "./NumberParser";
import { Point3DParser } from "./Point3DParser";
import { RangeParser } from "./RangeParser";
import { SelectableRangeParser } from "./SelectableRangeParser";
import { UnitParser } from "./UnitParser";
import { WeightedPressureUnitParser } from "./WeightedPressureUnitParser";

export class ParserCatalog {
    /**
     * Returns undefined when no parser found.
     */
    public static getParser(objectName: string): IWorkflowPropertyParser<unknown> {
        if (!objectName) return undefined;

        const parsers = Object.getOwnPropertyNames(ParserCatalog.Parsers);

        const idx = parsers.findIndex((x) => x.toLowerCase() == objectName.toLowerCase());

        if (idx >= 0) {
            return ParserCatalog.Parsers[parsers[idx]];
        }

        return undefined;
    }

    public static Parsers: { [objectName: string]: IWorkflowPropertyParser<unknown> } = {
        ChannelSelection: new ChannelSelectionParser(),
        MeasurementChannelSelection: new MeasurementChannelSelectionParser(),
        Number: new NumberParser(),
        Range: new RangeParser(),
        Unit: new UnitParser(),
        AxisKind: new AxisKindParser(),
        Boolean: new BooleanParser(),
        WeightedUnit: new WeightedPressureUnitParser(),
        SelectableRange: new SelectableRangeParser(),
        Point3D: new Point3DParser(),
    };
}
